// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';

import { IButtonProps } from './Button.types';
import { ButtonStyled } from './Button.styled';

export const BUTTON_TYPE: {
	SECONDARY: string;
	PRIMARY: string;
	DANGER: string;
} = {
	PRIMARY: 'PRIMARY',
	SECONDARY: 'SECONDARY',
	DANGER: 'DANGER',
};

const ButtonComponent = (props: IButtonProps): React.JSX.Element => {
	const {
		isLoading = false,
		label,
		onClick,
		htmlType,
		disabled = false,
		kind = BUTTON_TYPE.PRIMARY,
		rounded,
		icon,
		size,
		mobilePadding,
	} = props;

	const buttonProps = () => ({
		loading: isLoading,
		$width: props?.width,
		$mobileWidth: props?.mobileWidth,
		disabled,
		$kind: kind,
		$rounded: rounded,
		size: size || 'default',
		$mobilePadding: mobilePadding,
	});

	if (htmlType === 'submit') {
		return (
			<ButtonStyled htmlType={htmlType} {...buttonProps()}>
				{label} {icon}
			</ButtonStyled>
		);
	}

	return (
		<ButtonStyled onClick={onClick} {...buttonProps()}>
			{label} {icon}
		</ButtonStyled>
	);
};

export default ButtonComponent;
